<template>
  <div>
    <div v-if="type == 'vertical'">
      <div class="col-lg-12 p-0">
        <div class="row justify-content-center">
          <div
            v-for="(product, index) in products"
            :key="index"
            :class="colClasses"
          >
            <cardVertical
              :product="product"
              :index="index"
              :excerpt="excerpt"
              :size="size"
            ></cardVertical>
          </div>
        </div>
      </div>
    </div>

    <div v-if="type == 'horizontal'">
      <div class="col-lg-12">
        <div class="row justify-content-center">
          <div
            :class="colClasses"
            v-for="(product, index) in products"
            :key="index"
          >
            <cardHorizontal
              :product="product"
              :index="index"
              :excerpt="excerpt"
              :size="size"
            ></cardHorizontal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BCarousel } from "bootstrap-vue";
import { ProductsAPI } from "../../../core/api";
import cardVertical from "./cards/CardVertical.vue";
import cardHorizontal from "./cards/CardHorizontal.vue";
export default {
  name: "products-card",
  components: { "b-carousel": BCarousel, cardVertical, cardHorizontal },

  props: {
    colClasses: {
      type: String,
      required: false,
      default: ""
    },
    type: {
      type: String,
      required: true,
      default: "",
      description: "Type of boxes products:vertical-horizontal"
    },
    size: {
      type: String,
      required: false,
      default: "",
      description: "lg-md-sm"
    },
    excerpt: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show short description"
    },
    searchCriteria: {
      type: Object,
      required: true,
      description: "Search criteria"
    }
  },
  data() {
    return {
      imgCarousel: 0,
      sliding: null,
      carouselProduct: 0,
      products: [],
      pages: 3,
      currentPage: 1
    };
  },
  watch: {
    searchCriteria: {
      handler: async function(current, old) {
        this.products = await this.getFeaturedProducts(current);
      },
      deep: true
    }
  },
  async created() {
    this.products = await this.getFeaturedProducts(this.searchCriteria);
  },
  mounted() {},
  methods: {
    async getFeaturedProducts(searchCriteria) {
      try {
        let { data } = await ProductsAPI.getProductsBySearchCriteria(
          searchCriteria
        );
        if (data.status) {
          return data.data.docs;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    linkType: function(type) {
      if ("PRIVATE_TRANSFER" === type) {
        return "private-transfer";
      } else if ("TUORS" === type) {
        return "tours";
      } else if ("EVENT" === type) {
        return "event";
      } else if ("ATTRACTION" === type) {
        return "attraction";
      }
    }
  },
  filters: {
    serviceType: function(type) {
      if ("PRIVATE_TRANSFER" === type) {
        return "Private Transfer";
      } else if ("TUORS" === type) {
        return "Tours";
      } else if ("EVENT" === type) {
        return "Event";
      } else if ("ATTRACTION" === type) {
        return "Attraction";
      }
    }
  }
};
</script>
